<template>
  <asc-header
    class="asc-section-header"
    :value="title"
    size="h3"
    no-margins
    uppercase
  ></asc-header>
</template>

<script>
import AscHeader from './AscHeader'

export default {
  name: 'AscSectionHeader',

  components: {
    AscHeader,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.asc-section-header {
  .asc-header--h3 {
    font-size: 14px;
    font-weight: 500;
  }
}
</style>
